<template>
  <div class="space-y-8 animate-fade-in">
    
    <div class="bg-white p-8 rounded-[2.5rem] shadow-xl border-l-8 border-carpatina-portocaliu flex flex-col md:flex-row gap-8">
      
      <div class="md:w-1/3 space-y-6">
        <div>
            <h2 class="text-2xl font-black text-carpatina-gri uppercase tracking-tight flex items-center gap-2">
            <Megaphone class="text-carpatina-portocaliu" /> Centru Marketing
            </h2>
            <p class="text-sm text-gray-400 font-bold italic leading-relaxed mt-2">
            Aici gestionezi comunicarea cu clienții. Lansează alerte pe site sau trimite newslettere.
            </p>
        </div>

        <div class="bg-orange-50 p-5 rounded-3xl border border-orange-100 shadow-sm">
          <p class="text-xs text-orange-600 font-bold uppercase mb-1 flex items-center gap-2">
            <Users :size="14" /> Audiență Totală
          </p>
          <p class="text-4xl font-black text-carpatina-gri">{{ subscriberCount }}</p>
          <p class="text-xs text-gray-400 font-medium mt-1">Abonați la newsletter</p>
        </div>

        <div class="bg-green-50 p-5 rounded-3xl border border-green-100 shadow-sm">
          <p class="text-xs text-green-600 font-bold uppercase mb-1 flex items-center gap-2">
            <BellRing :size="14" /> Alerte Active
          </p>
          <p class="text-4xl font-black text-carpatina-gri">{{ alerts.length }}</p>
          <p class="text-xs text-gray-400 font-medium mt-1">Vizibile pe site</p>
        </div>
      </div>

      <form @submit.prevent="createCampaign" class="md:w-2/3 bg-gray-50 p-6 rounded-[2rem] border border-gray-100 space-y-4 shadow-inner">
        
        <div class="grid grid-cols-2 gap-4">
          <div class="col-span-2">
            <label class="text-[10px] font-black uppercase text-gray-400 ml-1">Titlu Alertă (Subiect Mail)</label>
            <input v-model="form.titlu" required type="text" placeholder="Ex: Reduceri Masive la Ciment!" 
                   class="w-full p-3 rounded-xl border-2 border-white focus:border-carpatina-portocaliu outline-none font-bold shadow-sm transition">
          </div>
          
          <div class="col-span-2">
            <label class="text-[10px] font-black uppercase text-gray-400 ml-1">Mesaj Scurt (Conținut)</label>
            <textarea v-model="form.text" required rows="2" placeholder="Ex: Doar săptămâna asta ai transport gratuit..." 
                      class="w-full p-3 rounded-xl border-2 border-white focus:border-carpatina-portocaliu outline-none font-medium shadow-sm transition"></textarea>
          </div>

          <div class="col-span-2">
            <label class="text-[10px] font-black uppercase text-gray-400 ml-1">Alege Iconița</label>
            <div class="grid grid-cols-4 gap-3 mt-1">
              <button type="button" v-for="opt in iconOptions" :key="opt.value" 
                      @click="form.icon = opt.value"
                      :class="form.icon === opt.value ? 'bg-carpatina-portocaliu text-white ring-2 ring-offset-2 ring-carpatina-portocaliu scale-105' : 'bg-white text-gray-400 hover:bg-gray-100'"
                      class="flex flex-col items-center justify-center gap-2 p-2 rounded-xl border border-gray-100 shadow-sm transition-all h-20">
                  <component :is="opt.icon" :size="24" />
                  <span class="text-[9px] font-bold uppercase">{{ opt.label }}</span>
              </button>
            </div>
          </div>

          <div class="col-span-2">
             <label class="flex items-center gap-4 bg-white p-4 rounded-xl border-2 border-gray-100 cursor-pointer hover:border-carpatina-portocaliu transition select-none shadow-sm">
                <div class="relative flex items-center">
                    <input type="checkbox" v-model="form.trimite_email" class="peer sr-only">
                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-carpatina-portocaliu"></div>
                </div>
                <div class="flex flex-col">
                    <span class="text-xs font-black uppercase text-carpatina-gri flex items-center gap-2">
                        <Mail :size="14" /> Trimite și Newsletter?
                    </span>
                    <span class="text-[10px] text-gray-400 font-medium">
                        Se va trimite un email HTML către toți cei <b>{{ subscriberCount }}</b> abonați.
                    </span>
                </div>
             </label>
          </div>
        </div>

        <button type="submit" :disabled="loading" 
                class="w-full bg-carpatina-gri hover:bg-carpatina-verde text-white py-4 rounded-xl font-black uppercase tracking-widest shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
          <Send v-if="!loading" :size="18" />
          {{ loading ? 'Se procesează...' : 'LANSEAZĂ CAMPANIA' }}
        </button>

      </form>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        
        <div class="bg-white rounded-[2.5rem] shadow-xl overflow-hidden border border-gray-100 h-fit">
            <div class="bg-carpatina-portocaliu p-6 text-white flex justify-between items-center">
                <h3 class="font-black uppercase tracking-widest flex items-center gap-2 text-sm">
                <BellRing :size="18" /> Alerte Active pe Site
                </h3>
                <button @click="fetchAlerts" class="p-2 hover:bg-white/10 rounded-full transition"><RefreshCw :size="16" /></button>
            </div>

            <div class="max-h-[400px] overflow-y-auto p-4 space-y-3">
                <div v-if="alerts.length === 0" class="text-center text-gray-400 py-10 font-bold italic text-xs">
                    Nicio alertă activă. Site-ul e curat.
                </div>

                <div v-for="alert in alerts" :key="alert.id" class="flex items-start gap-3 bg-gray-50 p-4 rounded-2xl border border-gray-100">
                    <div class="bg-white p-2 rounded-full shadow-sm text-carpatina-portocaliu">
                        <component :is="getIconComponent(alert.icon)" :size="20" />
                    </div>
                    <div class="flex-1">
                        <h4 class="font-black text-carpatina-gri text-xs uppercase">{{ alert.titlu }}</h4>
                        <p class="text-xs text-gray-500 leading-snug mt-1">{{ alert.text }}</p>
                        <p class="text-[10px] text-gray-300 mt-2 font-mono">{{ formatDate(alert.data_creare) }}</p>
                    </div>
                    <button @click="deleteAlert(alert.id)" class="text-gray-300 hover:text-red-500 transition p-2 hover:bg-red-50 rounded-lg" title="Șterge Alertă">
                        <Trash2 :size="16" />
                    </button>
                </div>
            </div>
        </div>

        <div class="bg-white rounded-[2.5rem] shadow-xl overflow-hidden border border-gray-100 h-fit flex flex-col">
            <div class="bg-carpatina-verde p-6 text-white">
                <div class="flex justify-between items-center mb-4">
                    <h3 class="font-black uppercase tracking-widest flex items-center gap-2 text-sm">
                        <Users :size="18" /> Bază de date Abonați
                    </h3>
                    <button @click="fetchSubscribers" class="p-2 hover:bg-white/10 rounded-full transition"><RefreshCw :size="16" /></button>
                </div>
                
                <div class="relative">
                    <input v-model="searchQuery" type="text" placeholder="Caută abonat după email..." 
                           class="w-full pl-9 pr-4 py-2 rounded-xl bg-white/20 border border-white/30 text-white placeholder-white/70 focus:outline-none focus:bg-white/30 text-xs font-bold transition">
                    <Search :size="14" class="absolute left-3 top-2.5 text-white/70" />
                </div>
            </div>

            <div class="max-h-[400px] overflow-y-auto">
                <table class="w-full text-left">
                <thead class="bg-gray-50 text-gray-400 text-[9px] uppercase font-black tracking-wider sticky top-0 z-10 shadow-sm">
                    <tr>
                    <th class="p-4 bg-gray-50">Email Client</th>
                    <th class="p-4 bg-gray-50">Data</th>
                    <th class="p-4 bg-gray-50 text-center">Acțiuni</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100 text-xs">
                    <tr v-for="sub in filteredSubscribers" :key="sub.id" class="hover:bg-gray-50 transition group">
                    <td class="p-4 font-bold text-carpatina-gri group-hover:text-carpatina-portocaliu transition-colors">
                        {{ sub.email }}
                    </td>
                    <td class="p-4 text-gray-500 italic">{{ formatDate(sub.data_abonare) }}</td>
                    <td class="p-4 text-center">
                        <button @click="deleteSubscriber(sub.id)" class="text-red-300 hover:text-red-500 transition p-2 hover:bg-red-50 rounded-lg">
                        <Trash2 :size="16" />
                        </button>
                    </td>
                    </tr>
                    
                    <tr v-if="filteredSubscribers.length === 0">
                        <td colspan="3" class="p-10 text-center text-gray-400 font-bold italic">
                            {{ searchQuery ? 'Niciun abonat găsit.' : 'Niciun abonat în listă.' }}
                        </td>
                    </tr>
                </tbody>
                </table>
            </div>
            
            <div class="p-2 bg-gray-50 border-t border-gray-100 text-[10px] text-gray-400 text-center font-bold">
                Total: {{ filteredSubscribers.length }} abonați filtrați
            </div>
        </div>

    </div>

  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { 
    Megaphone, Send, Users, Trash2, RefreshCw, Mail, 
    BellRing, Info, Tag, Truck, AlertTriangle, Search
} from 'lucide-vue-next';

const subscribers = ref([]);
const alerts = ref([]); 
const loading = ref(false);
const searchQuery = ref(''); // Variabilă pentru căutare

const form = ref({
  titlu: '',
  text: '',
  icon: 'Info',
  trimite_email: false
});

// Configurare Iconițe
const iconOptions = [
    { value: 'Info', label: 'Info', icon: Info },
    { value: 'Tag', label: 'Ofertă', icon: Tag },
    { value: 'Truck', label: 'Transport', icon: Truck },
    { value: 'AlertTriangle', label: 'Urgent', icon: AlertTriangle },
];

const iconMap = { Info, Tag, Truck, AlertTriangle };
const getIconComponent = (iconName) => iconMap[iconName] || Info;

const subscriberCount = computed(() => subscribers.value.length);

// Logica de Filtrare Abonați
const filteredSubscribers = computed(() => {
    if (!searchQuery.value) return subscribers.value;
    const lowerQuery = searchQuery.value.toLowerCase();
    return subscribers.value.filter(sub => 
        sub.email.toLowerCase().includes(lowerQuery)
    );
});

// --- FETCH DATA ---
const fetchSubscribers = async () => {
  try {
    const res = await axios.get('/admin/subscribers');
    subscribers.value = res.data;
  } catch (err) { console.error("Err subscribers"); }
};

const fetchAlerts = async () => {
    try {
        const res = await axios.get('/admin/alerte/toate'); 
        alerts.value = res.data;
    } catch(err) { console.error("Err alerts"); }
}

// --- ACTIONS ---
const createCampaign = async () => {
  if(form.value.trimite_email) {
      const confirm = await Swal.fire({
          title: 'Trimiți Newsletter?',
          text: `Mesajul va ajunge la toți cei ${subscriberCount.value} abonați! Ești sigur?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#00684a',
          confirmButtonText: 'DA, TRIMITE',
          cancelButtonText: 'Nu, doar alertă'
      });
      if(!confirm.isConfirmed) return;
  }

  loading.value = true;
  const fd = new FormData();
  fd.append('titlu', form.value.titlu);
  fd.append('text', form.value.text);
  fd.append('icon', form.value.icon);
  fd.append('activa', true);
  fd.append('trimite_email', form.value.trimite_email);

  try {
    await axios.post('/admin/alerta', fd);
    Swal.fire({ 
        title: 'Succes!', 
        text: 'Campania a fost lansată cu succes.',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
    });
    form.value = { titlu: '', text: '', icon: 'Info', trimite_email: false };
    fetchAlerts(); 
  } catch(err) {
    Swal.fire('Eroare', 'Ceva nu a mers.', 'error');
  } finally {
    loading.value = false;
  }
};

const deleteAlert = async (id) => {
    try {
        await axios.delete(`/admin/alerta/${id}`);
        alerts.value = alerts.value.filter(a => a.id !== id);
        Swal.fire({ title: 'Șters!', icon: 'success', toast: true, position: 'top-end', showConfirmButton: false, timer: 1500 });
    } catch(err) {
        Swal.fire('Eroare', 'Nu s-a putut șterge alerta', 'error');
    }
}

const deleteSubscriber = async (id) => {
    const confirm = await Swal.fire({
        title: 'Ștergi abonatul?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        confirmButtonText: 'Șterge'
    });

    if(confirm.isConfirmed) {
        try {
            await axios.delete(`/admin/subscriber/${id}`);
            subscribers.value = subscribers.value.filter(s => s.id !== id);
            Swal.fire('Șters!', '', 'success');
        } catch(err) {
            Swal.fire('Eroare', '', 'error');
        }
    }
}

const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('ro-RO', { day: '2-digit', month: 'short', hour: '2-digit', minute:'2-digit' });
}

onMounted(() => {
    fetchSubscribers();
    fetchAlerts();
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.5s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
/* Scrollbar subtire pentru liste */
::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: #f1f1f1; }
::-webkit-scrollbar-thumb { background: #ddd; border-radius: 10px; }
::-webkit-scrollbar-thumb:hover { background: #ccc; }
</style>